export default __webpack_public_path__ + "static/media/Jena_Vozzella.1b0d53ad.png";